import { useState } from "react";

import { useWorkspace } from "@/components/helpers/custom-hooks/use-workspace";
import {
  QueryScenariosOrderBy,
  QueryScenariosStatus,
  VisibilityScope,
} from "@/graphql";

export const useScenarioQueryParams = ({
  statusFilter,
}: {
  statusFilter?: QueryScenariosStatus;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState<QueryScenariosStatus>(
    statusFilter || QueryScenariosStatus.All,
  );
  const workspace = useWorkspace();
  const [selectedScopes, setSelectedScopes] = useState<VisibilityScope[]>([
    VisibilityScope.User,
    ...(workspace ? [VisibilityScope.Workspace] : []),
    VisibilityScope.Global,
  ]);
  const [selectedCollections, setSelectedCollections] = useState<string[]>([]);
  const [selectedOwner, setSelectedOwner] = useState<string | null>(null);
  const [selectedOrder, setSelectedOrder] = useState<QueryScenariosOrderBy>(
    QueryScenariosOrderBy.Default,
  );
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [query, setQuery] = useState<string | null>(null);

  const [selectedHasPracticed, setSelectedHasPracticed] = useState<
    boolean | null
  >(null);

  return {
    currentPage,
    setCurrentPage,
    selectedStatus,
    setSelectedStatus,
    selectedScopes,
    setSelectedScopes,
    selectedCollections,
    setSelectedCollections,
    selectedOwner,
    setSelectedOwner,
    selectedOrder,
    setSelectedOrder,
    selectedTags,
    setSelectedTags,
    query,
    setQuery,
    selectedHasPracticed,
    setSelectedHasPracticed,
  };
};
